import type { SearchResult, SearchGroup } from '../../lib/search-types';
import { PaletteItem } from './palette-item';

interface PaletteResultsProps {
  results: SearchResult[];
  activeIndex: number;
  onSelect: (result: SearchResult) => void;
  onHover: (index: number) => void;
}

function groupResults(results: SearchResult[]): [SearchGroup, SearchResult[]][] {
  const map = new Map<SearchGroup, SearchResult[]>();
  for (const r of results) {
    const group = map.get(r.group) ?? [];
    group.push(r);
    map.set(r.group, group);
  }
  return Array.from(map.entries());
}

export function PaletteResults({ results, activeIndex, onSelect, onHover }: PaletteResultsProps) {
  if (results.length === 0) return null;

  const groups = groupResults(results);
  let flatIndex = 0;

  return (
    <div role="listbox" aria-label="Søkeresultater" className="max-h-80 overflow-y-auto py-2">
      {groups.map(([group, items]) => (
        <div key={group}>
          {/* Gruppe-header med facet-telling */}
          <div className="flex items-baseline gap-2 px-4 pb-1 pt-2">
            <span className="text-[10px] font-semibold uppercase tracking-widest text-text-secondary">
              {group}
            </span>
            <span className="text-[10px] text-text-tertiary">{items.length}</span>
          </div>
          {items.map((item) => {
            const idx = flatIndex++;
            return (
              <PaletteItem
                key={item.id}
                result={item}
                isActive={idx === activeIndex}
                onSelect={onSelect}
                onMouseEnter={() => onHover(idx)}
              />
            );
          })}
        </div>
      ))}
    </div>
  );
}
